module.exports = __webpack_public_path__ + "img/hero-img-origin.f2157700.png";